import React from 'react';
import { CSS } from '@dnd-kit/utilities';

function classNames(...classes) {
	return classes.filter(Boolean).join(' ');
}

const CategoryRowItem = ({
	attributes,
	category,
	title,
	enabled,
	localCategory,
	parentTitle,
	listeners,
	nodeRef,
	transition,
	transform,
	handleClick,
}) => {
	const style = {
		transition,
		transform: CSS.Transform.toString(transform),
	};

	return (
		<div ref={nodeRef} style={style}>
			<div
				className={classNames(
					category.parentCategoryId ? 'text-gray-500' : '',
					'group flex items-center px-4 py-4 hover:cursor-pointer',
				)}>
				<div
					className={classNames(
						category.parentCategoryId ? 'px-8' : 'px-4',
						'flex flex-1 text-sm font-medium w-5/6',
					)}
					onClick={() => handleClick(localCategory.id)}>
					<div className="flex-shrink-0">{title}</div>
				</div>
				<div
					className="flex text-sm font-medium text-gray-400 w-1/6"
					onClick={e => console.log('click enabled')}>
					{enabled && <span>Enabled</span>}
					{!enabled && <span>Disabled</span>}
				</div>
				<div>
					<div {...attributes} {...listeners} className="invisible group-hover:visible">
						<svg viewBox="0 0 20 20" width="12">
							<path d="M7 2a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 2zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 8zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 14zm6-8a2 2 0 1 0-.001-4.001A2 2 0 0 0 13 6zm0 2a2 2 0 1 0 .001 4.001A2 2 0 0 0 13 8zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 13 14z"></path>
						</svg>
					</div>
				</div>
			</div>
		</div>
	);
};

export default CategoryRowItem;
